import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'
import shSymbol from 'images/tmp_shinhyup_symbol.png'
import nhSymbol from 'images/tmp_nh_symbol.png'
import styles from './index.module.css'

const InfluencerDetail = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					<h4><strong>불뿜는오리123</strong>님의<br />포트폴리오</h4>
					<div className="slider mt_10">
						<ul className={styles["box-line"]}>
							<li>
								<div className="balance" style={{ padding: "0 1rem" }}>
									<span className="icon icon_balance_arrow" />
									<ul className="balance-area">
										<li>
											<span className="icon money-many mt_0" style={{ width: "8rem", height: "5.1rem" }} />
											<p className="price price-today" style={{ fontSize: "1.6rem" }}>20,000,000 원</p>
										</li>
										<li>
											<span className="icon money-less mt_0" style={{ width: "8rem", height: "5.1rem" }} />
											<p className="price">19,950,000 원</p>
										</li>
									</ul>
								</div>
							</li>
						</ul>
						<ul className="slider-dots dots-gray mt_20">
							<li className="active" />
							<li />
							<li />
						</ul>
					</div>
					<div className="mt_50">
						<div className="flex-justify_between align_center mt_30">
							<strong>2021.12.13 (월)</strong>
							<span className="write-btn"><i className="icon icon_write icon_write mr_5" />수정</span>
						</div>
						<div className="mt_10 flex-align_center" style={{ fontSize: "1.6rem" }}>어제대비<strong className="text-red ml_5">+50,000 원</strong></div>
						<hr className="my_20" />
						<div>
							어제 급여가 들어와서 잔고가 3,000만원이 되었다. 내일은 다시 제로가 되겠지만 오늘 하루만이라도 웃자^^
							어제 급여가 들어와서 잔고가 3,000만원이 되었다. 내일은 다시 제로가 되겠지만 오늘 하루만이라도 웃자^^
						</div>
					</div>
				</div>
			</div>
			<ul className={`${styles["bank-list"]} list-bg mt_40`}>
				<li>
					<div className="flex-align_center">
						<div className="img-box img-symbol">
							<img src={shSymbol} alt="" />
						</div>
						<span className="ml_10">신협은행</span>
					</div>
					<div>
						<p className={styles.price}>324,850원</p>
						<span className={`${styles.info} plus`}>+50,000 원</span>
					</div>
				</li>
				<li>
					<div className="flex-align_center">
						<div className="img-box img-symbol">
							<img src={nhSymbol} alt="" />
						</div>
						<span className="ml_10">농협은행</span>
					</div>
					<div>
						<p className={styles.price}>324,850원</p>
						<span className={`${styles.info} minus`}>-152,250 원</span>
					</div>
				</li>
			</ul>
			<div className="padding pb_50">
				<Button className="btn btn--big btn-more">+ 더보기</Button>
			</div>
		</div>
	)
}

export default InfluencerDetail
